const impact_data = [
  {
    id: "1",
    img: "https://www.zindagitrust.org/img/news/kfc1.jpeg",
    title: "COLLABORATION WITH KFC & TECHNOKNOWLEDGE",
    detail:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
  {
    id: "2",
    img: "https://www.zindagitrust.org/img/coronavirus/c2.jpg",
    title: "Prime Minister Imran Khan acknowledging",
    detail:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
  {
    id: "3",
    img: "https://www.zindagitrust.org/img/coronavirus/c1.jpg",
    title: "The changing role of schools in this new world",
    detail:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
  {
    id: "4",
    img: "https://www.geo.tv/assets/uploads/updates/2022-08-23/435584_8346775_updates.jpg",
    title: "INITIATE DIGITAL SAFETY WORKSHOPS IN GOVT SCHOOLS",
    detail:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
  {
    id: "5",
    img: "https://www.zindagitrust.org/news/cpad.jpg",
    title: "lorem ipsum dolare site amite among",
    detail:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
  {
    id: "6",
    img: "https://www.zindagitrust.org/news/cpad.jpg",
    title: "lorem ipsum dolare site amite among",
    detail:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
  {
    id: "7",
    img: "https://www.zindagitrust.org/img/news/kfc1.jpeg",
    title: "lorem ipsum dolare site amite among",
    detail:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
  {
    id: "8",
    img: "https://www.zindagitrust.org/img/coronavirus/c2.jpg",
    title: "lorem ipsum dolare site amite among",
    detail:
      "Some quick example text to build on the card title and make up the bulk of the card's content.",
  },
];

export default impact_data;
